import { render, staticRenderFns } from "./SampleCheckout.vue?vue&type=template&id=bfd32d70&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SampleCheckout.vue?vue&type=script&lang=js&"
export * from "./SampleCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd32d70",
  null
  
)

export default component.exports